export class Sort {
  constructor(public property: string, public direction: SortDirection) { }
}

export enum SortDirection {
  Asc = 1,
  Desc = -1
}

